import Box from '@mui/material/Box';

import { Ticket } from '~hooks/useTickets/models';

import MaterialColumn from './Columns/MaterialColumn';
import PrintTimeColumn from './Columns/PrintTimeColumn';
import SourceColumn from './Columns/SourceColumn';
import StatusColumn from './Columns/StatusColumn';
import TicketColumn from './Columns/TicketColumn';
import TruckAndVendorColumn from './Columns/TruckAndVendorColumn';
import { columns, gridTemplateColumns } from './tickets-table-columns';

const rowGridColumn = `span ${columns.length}`;

interface TableRowProps {
  ticket: Ticket;
}

export default function TableRow({ ticket }: TableRowProps) {
  return (
    <Box
      sx={(theme) => ({
        borderBottom: `solid 1px ${theme.palette.divider}`,
        display: 'grid',
        gridAutoRows: '60px',
        gridColumn: rowGridColumn,
        gridTemplateColumns,
        overflow: 'hidden',
        '&:hover': {
          bgcolor: theme.palette.action.hover,
        },
      })}
    >
      <TruckAndVendorColumn sx={{ ...columns[0].sx }} ticket={ticket} />
      <MaterialColumn sx={{ ...columns[1].sx }} ticket={ticket} />
      <TicketColumn sx={{ ...columns[2].sx }} ticket={ticket} />
      <PrintTimeColumn sx={{ ...columns[3].sx }} ticket={ticket} />
      <StatusColumn sx={{ ...columns[4].sx }} ticket={ticket} />
      <SourceColumn sx={{ ...columns[5].sx }} ticket={ticket} />
    </Box>
  );
}
